import React from 'react';
import { BaseComponent } from 'components/BaseComponent';
import Grid from '@material-ui/core/Grid/Grid';
import MultipleInstallments from 'components/Cart/Price/MultipleInstallments';
import WithoutInstallment from 'components/Cart/Price/WithoutInstallment';
import { IProductData } from 'interfaces/IProductData';
import UserInfos from 'components/Cart/Templates/Mobile/OneClickBuy/UserInfos';
import Installments from 'components/Cart/MainForm/Payment/PaymentForm/CreditCardForm/Installments';
import CreditCard from 'components/Cart/Templates/Mobile/OneClickBuy/CreditCard';
import { paymentService } from 'services/PaymentService';
import { cartService } from 'services/CartService';
import Translate from 'components/Translate';
import { Subscription } from 'components/Cart/Price/Subscription';
import AcceptTerms from 'components/AcceptTerms';
import { enPaymentType } from 'enums/enPaymentType';
import PaymentButton from 'components/Cart/PaymentButton';
import { FieldValidation } from 'components/Field';

interface IProps {
  onPay?: any;
  cart?: IProductData;
  disableButton?: boolean;
}

export class ContentOneClickBuy extends BaseComponent<null, IProps> {

  editInfos = () => {
    paymentService.setPaymentData(0, { paymentMethod: null });

    cartService.enableAskAddress().subscribe();
    cartService.disableOneClickBuy().subscribe();
  }

  finish = async () => {
    if (await this.isFormValid()) {
      this.props.onPay();
    }
  }

  render() {

    const { cart } = this.props;

    return (
      <div>
        <FieldValidation.Provider value={this.registerFields}>
          <Grid
            className='chk-oneClickBuy__product'
            container
            direction='row'
            justify='space-between'
            alignItems='center'
          >
            <Grid item xs={6} className='chk-oneClickBuy__title'>
              <h1 className='product-name'>{cart.title}</h1>
            </Grid>
            <Grid item xs={6} className='chk-oneClickBuy__productPrice'>
              {[enPaymentType.NORMAL, enPaymentType.ECOMMERCE].includes(cart.paymentType)
                ? cart.installments.length > 1
                  ? <MultipleInstallments cart={cart} />
                  : <WithoutInstallment cart={cart} />
                : null
              }

              {cart.paymentType === enPaymentType.SUBSCRIPTION
                ? <Subscription subscription={cart.subscription} />
                : null
              }
            </Grid>
          </Grid>

          <Grid item xs={12} className='chk-oneClickBuy__content'>
            <div className='chk-oneClickBuy__form'>
              <CreditCard creditCard={cart.user.creditCard} askCVV={cart.config.askCVV} />

              <Installments index={0} />

              <Grid item xs={12}>

                <PaymentButton
                  finish={this.finish}
                  disabledButton={this.props.disableButton}
                  messageButton='Compra Segura'
                />

                {cart.paymentType == enPaymentType.SUBSCRIPTION
                  ? <AcceptTerms />
                  : null
                }
              </Grid>

              <div className='chk-oneClickBuy__details' id='ocb-details'>
                <h6><Translate term='Detalhes do Pedido' /></h6>
                <UserInfos infos={[cart.user.name, cart.user.email]} />
              </div>

              <div className='chk-oneClickBuy__editInfosButton theme-label'>
                <a id='chk-editdata-button' href='#' onClick={this.editInfos}><Translate term='Editar dados' /></a>
              </div>
            </div>
          </Grid>
        </FieldValidation.Provider>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Cart/Templates/Hotsite/OneClickBuy/ContentOneClickBuy/index.tsx